/** Preserve published language characters while turning accidental spacing into URL separators. */
export function normalizeBlogPostSlug(slug: string): string {
  // Decode stored URL bytes before URLs are encoded once by the href builder.
  for (let pass = 0; pass < 3 && /%[0-9a-f]{2}/i.test(slug); pass++) {
    try {
      const decoded = decodeURIComponent(slug);
      if (decoded === slug || /[/?#]/.test(decoded)) break;
      slug = decoded;
    } catch { break; }
  }
  return slug.normalize("NFC").replace(/%20/gi, " ").trim().replace(/\s+/g, "-").replace(/-{2,}/g, "-");
}

/** Exact, escaped compatibility lookup for Mongo rows that still contain spaces. */
export function legacyBlogPostSlugPattern(slug: string): RegExp | null {
  if (normalizeBlogPostSlug(slug) !== slug || !slug.includes("-")) return null;
  const words = slug.split("-").map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  return new RegExp(`^(?:\\s|%20)*${words.join("(?:-|\\s|%20)+")}(?:\\s|%20)*$`);
}
